<template>
    <div class="container">
        <!-- 查询条件数据 -->
        <div class="query-container" style="width:95%;">  
            <div style="display: inline-block; height:40px;">
                <el-select v-model="form.deptId" placeholder="请选择学校">
                    <el-option
                        v-for="item in depts"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id">
                    </el-option>
                </el-select>
            </div>
            <div style="display: inline-block; height:40px;">
                <el-input v-model="form.leaveNo" placeholder="审批编号" style="width: 130px;"></el-input>
            </div>
            <div style="display: inline-block; height:40px;">
                <el-input v-model="form.name" placeholder="申请人" style="width: 130px;"></el-input>
            </div>
            <div style="display: inline-block; height:40px;">
                <el-button type="primary" icon="search" @click="common.page = 1;getData()">查询</el-button>
                <el-button type="primary" @click="exportExcel">导出Excel</el-button>
            </div>
        </div>

        <div class="table-container">
            <el-table
                :data="data"
                v-loading="loading"
                :element-loading-text="loadingText"
                element-loading-spinner="el-icon-loading"
                element-loading-background = "rgba(255, 255,255,0.7)"
                border
                default-expand-all>
                    <el-table-column type="index" label="序号"  width="55" :index="indexMethod"></el-table-column>
                    <el-table-column prop="leaveNo" label="审批编号" width="100"></el-table-column>
                    <el-table-column prop="createUser" label="申请人" width="80"></el-table-column>
                    <el-table-column prop="" label="所属机构" width="100">
                        <template slot-scope="scope">
                            {{scope.row.className}}
                        </template>
                    </el-table-column>
                    <el-table-column prop="" label="请假类型" width="100">
                        <template slot-scope="scope">
                            <span v-if="scope.row.sourceType == 1">
                                请假
                            </span>
                            <span v-else-if="scope.row.sourceType == 2">
                                补卡
                            </span>
                            <span v-if="scope.row.typeName != null">-{{scope.row.typeName}}</span>
                            <span v-else>
                                <span v-if="scope.row.type == 1">
                                    -事假
                                </span>
                                <span v-else-if="scope.row.type == 2">
                                    -病假
                                </span>
                                <span v-else-if="scope.row.type == 3">
                                    -产假
                                </span>
                                <span v-else-if="scope.row.type == 4">
                                    -公假
                                </span>
                                <span v-else-if="scope.row.type == 5">
                                    -休假
                                </span>
                            </span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="" label="开始时间或者补卡时间" width="100">
                        <template slot-scope="scope">
                            <div v-if="scope.row.sourceType == 1">
                                {{scope.row.startDate}}
                            </div>
                            <div v-else-if="scope.row.sourceType == 2">
                                {{scope.row.patchCardDatetime}}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="endDate" label="结束时间" width="100"></el-table-column>
                    <el-table-column prop="value" label="请假时长(天)" width="100"></el-table-column>
                    <el-table-column prop="remark" label="请假原因" :show-overflow-tooltip="true"></el-table-column>
                    <el-table-column prop="" label="审核状态" width="100">
                        <template slot-scope="scope">
                            <div v-if="scope.row.status == 1">
                                审批中
                            </div>
                            <div v-else-if="scope.row.status == 2">
                                拒绝
                            </div>
                            <div v-else-if="scope.row.status == 3">
                                通过
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="checkRemark" label="审核备注" width="100"></el-table-column>
                    <el-table-column prop="gmtCreate" label="申请时间" width="100"></el-table-column>
                    <el-table-column fixed="right" label="操作" width="80px" style="text-align:'left'">
                        <template slot-scope="scope">
                            <el-button style="color:#387EE8;" v-if="(scope.row.image1Url != null && scope.row.image1Url != '')
                            || (scope.row.image2Url != null && scope.row.image2Url != '') || (scope.row.image3Url != null && scope.row.image3Url != '')"
                                @click.native.prevent="showFile(scope.row)"
                                type="text"
                                size="small">
                                查看附件
                            </el-button>
                            <el-button style="color:#387EE8;"
                                @click.native.prevent="showFlow(scope.row)"
                                type="text"
                                size="small">
                                审批信息
                            </el-button>
                        </template>
                    </el-table-column>
 
            </el-table>

             <div class="pagination">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="common.page"
                    :page-size="common.pageSize"
                    :page-sizes="common.allSizes"
                    layout="total,sizes, prev, pager, next, jumper"
                    :total="common.total">
                </el-pagination>
            </div>
        </div>
         <!-- 查看附件弹出框 -->
        <div v-if="levaeFileVisible">
            <levaeFile ref="levaeFile"></levaeFile>
        </div>
         <!-- 查看流程弹出框 -->
        <div v-if="levaeFlowVisible">
            <levaeFlow ref="levaeFlow"></levaeFlow>
        </div>
    </div>
</template>

<script>
    import axios from 'axios';
    import http from '../../../common/http';
    import levaeFile from './LevaeFile.vue';
    import levaeFlow from './LevaeFlow.vue';

    export default {
        name:"Levae",
        data(){
            return{
                levaeFileVisible:false,
                levaeFlowVisible:false,
                loading:false,
                loadingText:"",
                common:{
                    total:0,            //总数据量
                    pageSize:30,        //每页条数
                    page:1,              //页码
                    isPage:1,            //是否分页
                    allSizes:[30,50,100], //每页条数筛选
                    checkboxArr:[]       //多选框数组
                },
                form:{
                    name:"",
                    leaveNo:"",
                    deptId:"",
                },
                depts:[],
                data:[]
            }
        },
        components: {
            levaeFile,levaeFlow
        },
        created:function () {
            this.getDeptData();
        },
        methods:{
            indexMethod(index) {
                return (this.common.page-1)*this.common.pageSize+(index+1);
            },
            getDeptData(){
                //部门管理
                let url  = this.listDeptUrl;
                let data = {parentId:"0"};
                this.apiPost(url,data).then((res) => {
                    if(res.status==200){
                       this.depts=res.data.list;
                       if(this.depts.length>0){
                           this.form.deptId=this.depts[0].id;
                        }
                        this.getData();
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                },(err)=>{
                    console.log(err);
                });
            },
            getData(){
                this.loading=true;
                this.loadingText="正在加载中...";
                let url  = this.leaveListUrl;
                let data = {
                    isPage:this.common.isPage,
                    page:this.common.page,
                    limit:this.common.pageSize,
                    deptId:this.form.deptId,
                    personType:2,
                    createUser:this.form.name,
                    leaveNo:this.form.leaveNo
                };       
                // console.log(JSON.stringify(data))
                this.apiPost(url,data).then((res) => {
                    // console.log(JSON.stringify(res.data.list));
                    if(res.status==200){
                        this.data = res.data.list;
                        this.common.total=res.data.total;
                        this.loading=false;
                    }else{
                        this.$commonFn.showTip(res.message,3);
                        this.loading=false;
                    }
                },(err)=>{
                    this.loading=false;
                });
            },
            handleSizeChange(val) {
                this.common.pageSize = val;
                this.common.page = 1;
                this.getData();
            },
            handleCurrentChange(val) {
                this.common.page = val;
                this.getData();
            },
            //查看附件
            showFile(row){
                this.levaeFileVisible=true;
                this.$nextTick(() => {
                    this.$refs['levaeFile'].init(row);
                })
            },
            //查看流程
            showFlow(row){
                this.levaeFlowVisible=true;
                this.$nextTick(() => {
                    this.$refs['levaeFlow'].init(row);
                })
            },
            exportExcel(){
                this.loading=true;
                this.loadingText="正在导出中，导出过程时间可能会比较长，请耐心等待";

                let url=this.leaveExportExcelUrl;
                console.log("url:"+url);
                let param = new URLSearchParams();
                param.append('deptId', this.form.deptId);
                param.append('personType', 2); 
                param.append('createUser', this.form.name);
                param.append('leaveNo', this.form.leaveNo);

                axios({
                    method: "post",
                    url: url,
                    data: param,
                    responseType: "blob"
                }).then(res => {
                    const link = document.createElement("a");
                    let blob = new Blob([res.data], { type: "application/vnd.ms-excel" });
                    link.style.display = "none";
                    link.href = URL.createObjectURL(blob);
                    link.setAttribute("download", '教职请假.xls');
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    this.loading=false;
                }).catch(error => {
                    // this.$Notice.error({
                    //     title: "错误",
                    //     desc: "系统数据错误"
                    // });
                    console.log(error); 
                    this.loading=false;
                });
            },
            
        },
        mixins: [http]
    }

</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/page/count/TeacherLevae.vue